import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { SALES } from '../constants';
import { commonTernary } from './commercialService';
import { wcApiUrl } from '../WebComponents/commonComponents/customUtils';

export const mobileValidation = async (phone, accessToken, initiateUiResponse, env, isWCFlow) => {
  let response = null;
  const uuid = uuidv4();
  const data = [
    {
      recordId: uuid,
      phoneNumber: phone,
    },
  ];

  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        `${wcApiUrl(env).REACT_APP_MOBILE_URL}`,
        `${initiateUiResponse.REACT_APP_MOBILE_URL}`
      ),
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          appid: SALES,
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};

export const getEmailVerificationData = async (
  email,
  accessToken,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  let response = null;
  const uuid = uuidv4();
  const data = [
    {
      recordId: uuid,
      email,
    },
  ];
  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_EMAIL_VERIFICATION_URL,
        initiateUiResponse.REACT_APP_EMAIL_VERIFICATION_URL
      ),
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};
export const mobileValidationExpress = async (
  phone,
  accessToken,
  customerAppId,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  let response = null;
  const uuid = uuidv4();
  const data = [
    {
      recordId: uuid,
      phoneNumber: phone,
    },
  ];
  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        `${wcApiUrl(env).REACT_APP_MOBILE_URL}`,
        `${initiateUiResponse.REACT_APP_MOBILE_URL}`
      ),
      data,
      {
        headers: {
          'Application-Id': customerAppId,
          appid: SALES,
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};

export const getEmailVerificationDataExpress = async (
  email,
  accessToken,
  customerAppId,
  initiateUiResponse,
  { env, isWCFlow }
) => {
  let response = null;
  const uuid = uuidv4();
  const data = [
    {
      recordId: uuid,
      email,
    },
  ];
  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        wcApiUrl(env).REACT_APP_EMAIL_VERIFICATION_URL,
        initiateUiResponse.REACT_APP_EMAIL_VERIFICATION_URL
      ),
      data,
      {
        headers: {
          'Application-Id': customerAppId,
          appid: SALES,
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};
